module.exports = __webpack_public_path__ + "static/media/profile-1.03dc71f9.svg";